<div class="app-time-input"
     [class.app-time-input--focused]="focused()"
     [class.app-time-input--disabled]="disabled()"
     (click)="onContainerClick($event)">

  <!-- Clock icon -->
  @if (showIcon()) {
    <i class="pi pi-clock app-time-input__icon"></i>
  }

  <!-- Hour segment — uncontrolled: Angular never writes [value] during typing -->
  <input #hourInput
    class="app-time-input__segment"
    type="tel"
    inputmode="numeric"
    maxlength="2"
    [attr.placeholder]="hasValue() ? null : 'HH'"
    [disabled]="disabled()"
    aria-label="Hour"
    autocomplete="one-time-code"
    (focus)="onSegmentFocus('hour', $event)"
    (blur)="onSegmentBlur('hour', $event)"
    (input)="onHourInput($event)"
    (keydown)="onHourKeydown($event)" />

  <!-- Separator -->
  <span class="app-time-input__sep">:</span>

  <!-- Minute segment — uncontrolled: Angular never writes [value] during typing -->
  <input #minuteInput
    class="app-time-input__segment"
    type="tel"
    inputmode="numeric"
    maxlength="2"
    [attr.placeholder]="hasValue() ? null : 'MM'"
    [disabled]="disabled()"
    aria-label="Minute"
    autocomplete="one-time-code"
    (focus)="onSegmentFocus('minute', $event)"
    (blur)="onSegmentBlur('minute', $event)"
    (input)="onMinuteInput($event)"
    (keydown)="onMinuteKeydown($event)" />

  <!-- AM/PM toggle (PrimeNG SelectButton) -->
  <p-selectButton
    [options]="periodOptions"
    [ngModel]="period()"
    (ngModelChange)="onPeriodChange($event)"
    optionLabel="label"
    optionValue="value"
    [disabled]="disabled()"
    [allowEmpty]="false"
    class="app-time-input__period" />
</div>
